import { motion, useAnimation } from 'framer-motion'
import NumberAnimate from '../../NumberAnimate'
import SVGJSContainer, {
	textVariants,
	pathMove
} from '../../../utils/SVGJSContainer'

function Promouvoir3() {
	const controls = useAnimation()

	return (
		<SVGJSContainer controls={controls}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="764"
				height="798.119"
				viewBox="0 0 764 798.119"
			>
				<g data-name="Groupe 2568" transform="translate(-191 -2336)">
					<g
						stroke="#fff"
						data-name="Groupe 2539"
						transform="translate(-31.555 116)"
					>
						<path
							fill="#a9d5d8"
							strokeWidth="8"
							d="M0 0H749V749H0z"
							data-name="Rectangle 2270"
							transform="translate(233.555 2224)"
						></path>
						<motion.path
							fill="#00849b"
							strokeWidth="20"
							d="M0 0H297.5V297.5H0z"
							data-name="Rectangle 2271"
							transform="translate(238.555 2669.5)"
							variants={pathMove}
							initial="hidden"
							animate={controls}
						></motion.path>
					</g>
					<text
						data-name="34"
						fontFamily="AcuminPro-Bold, Acumin Pro"
						fontSize="150"
						fontWeight="700"
						letterSpacing="-.05em"
						transform="translate(549.051 2886.881)"
					>
						<tspan x="0" y="0">
							<NumberAnimate
								tspan
								decimals={1}
								nb={86.6}
								duration={2.5}
								delay={0.8}
							/>
						</tspan>
					</text>
					<text
						data-name="M€"
						fontFamily="AcuminPro-Regular, Acumin Pro"
						fontSize="75"
						letterSpacing="-.02em"
						transform="translate(810.557 2845.085)"
					>
						<tspan x="0" y="0">
							M€
						</tspan>
					</text>

					<motion.text
						data-name="Essential coats what"
						fontFamily="AcuminPro-Regular, Acumin Pro"
						fontSize="40"
						transform="translate(558.335 2914.119)"
						variants={textVariants}
						initial="hidden"
						animate={controls}
					>
						<tspan x="0" y="29">
							consacrés{' '}
						</tspan>
						<tspan fontFamily="AcuminPro-Bold, Acumin Pro" fontWeight="700">
							<tspan x="0" y="74">
								à l’entretien{' '}
							</tspan>
							<tspan x="0" y="119">
								du patrimoine
							</tspan>
						</tspan>
					</motion.text>
				</g>
			</svg>
		</SVGJSContainer>
	)
}

export default Promouvoir3
